export function MapSection() {
  return (
    <div className="h-[400px] w-full bg-gray-200">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2845.5029820353837!2d10.6866!3d44.5986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477ffe5f5f5f5f5f%3A0x5f5f5f5f5f5f5f5f!2sVia%20del%20Lavoro%204%2C%2042019%20Scandiano%20RE!5e0!3m2!1sit!2sit!4v1609459200000!5m2!1sit!2sit"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Simertec Location"
      />
    </div>
  )
}
